export type CookieConsent = {
  necessary: boolean;
  analytics: boolean;
  marketing: boolean;
  timestamp: number;
  version: string;
};

export const CONSENT_COOKIE_NAME = 'cookie_consent_v1';
export const CONSENT_VERSION = '1.0';

/** Dispatched after saveConsent in CookieBanner (same-tab updates). */
export const COOKIE_CONSENT_UPDATED_EVENT = 'cookie-consent-updated';

export const getConsentFromCookie = (): CookieConsent | null => {
  if (typeof document === 'undefined') return null;

  const all = document.cookie.split(';').map((c) => c.trim());
  const entry = all.find((c) => c.startsWith(`${CONSENT_COOKIE_NAME}=`));
  if (!entry) return null;

  const value = entry.substring(CONSENT_COOKIE_NAME.length + 1);
  try {
    return JSON.parse(decodeURIComponent(value)) as CookieConsent;
  } catch {
    return null;
  }
};

export const setConsentCookie = (consent: CookieConsent) => {
  if (typeof document === 'undefined') return;

  const maxAgeSeconds = 60 * 60 * 24 * 365;
  const encoded = encodeURIComponent(JSON.stringify(consent));
  document.cookie = `${CONSENT_COOKIE_NAME}=${encoded}; Max-Age=${maxAgeSeconds}; Path=/; SameSite=Lax`;
};

export const hasStoredAnalyticsConsent = (): boolean => {
  const parsed = getConsentFromCookie();
  return Boolean(parsed?.analytics && parsed.version === CONSENT_VERSION);
};
